<template>
  <div>
    <a-card class="customer-filter">
      <task-filter-form v-model="filterForm" type="task" @change="handleChange" @reset="onReset" />
    </a-card>
    <a-card title="任务列表" size="small" class="filter-data">
      <span slot="extra">
        <task-view ref="view" @setFilter="setFilter" />
        <a-button v-has="{ code: 'project:task:add', project: projectId }" v-tc="{ name: '添加任务' }" class="handle-menu" type="link" icon="plus" @click="onAdd">添加任务</a-button>
      </span>
      <task-data-list ref="taskDataListRef" :customer-fields="customerFields" type="task" />
    </a-card>
  </div>
</template>
<script>
import TaskView from '@/pages/project/task/components/TaskView';
import TaskDataList from '@/pages/project/task/components/TaskDataList';
import TaskFilterForm from '@/pages/project/task/components/TaskFilterForm';

export default {
  components: { TaskDataList, TaskView, TaskFilterForm },
  data() {
    return {
      customerFields: [],
      loading: false,
      projectId: parseInt(this.$route.params.project_id) || null,
      excludeFields: [],
      filterForm: {
        sort_field: null,
        sort: null,
        start_time: null,
        end_time: null,
        about: 'all',
        time_filter_key: 'pre_time'
      }
    };
  },

  methods: {
    onReset(filter) {
      this.setFilter({ ...filter });
      this.$nextTick(() => {
        this.$refs.taskDataListRef.pagination.pageSize = this.$store.getters.pageSize;
        this.$refs.view.resetView();
      });
    },

    setFilter(filter) {
      this.filterForm = {
        ...filter,
        sort: null,
        sort_field: null,
        about: filter.about || 'all'
      };
      this.$nextTick(() => {
        this.$refs.taskDataListRef.setFilter(filter);
      });
    },

    handleChange(filter) {
      this.$nextTick(() => {
        this.$refs.taskDataListRef.search(filter);
      });
    },

    /**
     * 点击添加任务
     */
    onAdd() {
      this.$nextTick(() => {
        this.$refs.taskDataListRef.onAdd();
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.customer-filter .ant-card-body {
  padding: 12px !important;
}
.filter-data {
  margin-top: 16px;
}
</style>
